const turf = require('@turf/turf');
const { Bounce } = require('react-toastify');
const { default: Axios } = require('../axiosInstance');


let persistKeys = ["tripBookmarked"]

const _isEmbedded = (() => {
  try {
    if (window.self !== window.top) return true;
  } catch (e) {
    return true;
  }
  return new URLSearchParams(window.location.search).get('is_embedded_in_parent') === '1';
})();

exports.getIsEmbedded = () => _isEmbedded;

// Function to get user's current location
exports.getUserCurrentLocation = () => {
    return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    resolve({
                        status: true,
                        message: "Successfully fetched user coordinates",
                        coordinates: [longitude, latitude]
                    });
                },
                (error) => {
                    console.error("Error getting user location:", error);
                    reject({
                        status: false,
                        message: "Failed to get user location. Please enable location services."
                    });
                }
            );
        } else {
            reject({
                status: false,
                message: "Geolocation is not supported by this browser."
            });
        }
    });
}


exports.calculateDistance = async (selectedPlace, unit = 'miles') => {
let hotelData = {}
   try {
    hotelData = JSON.parse(localStorage.getItem("hotelInfo"))
   } catch (error) {
    console.log(error);
    return {
      status: false,
      message: "Please provide coordinates"
    };
   }
  // console.log(hotelData);
  
  if (!selectedPlace || Object.keys(hotelData).length === 0) {
    return {
      status: false,
      message: "Please provide coordinates"
    };
  }

  try {
    // Validate unit input
    const validUnits = ['miles', 'meters'];
    if (!validUnits.includes(unit)) {
      return {
        status: false,
        message: "Invalid unit. Please use 'miles' or 'meters'."
      };
    }

    // Get user location and create Turf.js points
    // const userLocation = await this.getUserCurrentLocation();
    // const userPoint = turf.point(userLocation.coordinates);
    const userPoint = turf.point([hotelData.latitude,hotelData.longitude])
    const placePoint = turf.point(selectedPlace);

    // Calculate distance in the selected unit
    let option = { units: unit === 'meters' ? 'kilometers' : 'miles' }; // Turf uses km for meters conversion
    let distance = turf.distance(userPoint, placePoint, option);

    // Convert kilometers to meters if required
    if (unit === 'meters') {
      distance *= 1000; // Convert km to meters
     distance = Math.ceil(distance * 10) / 10;
      return {
        status: true,
        message: "Successfully calculated",
        data: `${distance.toLocaleString()} m`
      };
    }

    // Return distance in miles
   distance = Math.ceil(distance * 10) / 10;
    return {
      status: true,
      message: "Successfully calculated",
      data: `${distance.toLocaleString()} mi`
    };
  } catch (error) {
    console.error(error);
    return {
      status: false,
      message: "Error calculating distance",
      error: error.message
    };
  }
};


exports.toastObj = {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
    }

    exports.getCustomMarker = ( color = "#080808") => {
        const encodedColor = encodeURIComponent(color);
        return `data:image/svg+xml,%3Csvg stroke='currentColor' style='color: ${encodedColor};' fill='currentColor' stroke-width='0' viewBox='0 0 384 512' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z'%3E%3C/path%3E%3C/svg%3E`;
    }
    

    exports.getDirectionUrl = (name) => {
        const encoded = encodeURI(name);
        return `https://www.google.com/maps/dir/?api=1&destination=${encoded}`
    }
    exports.getDirectionUrlFromCoordinates = (latitude, longitude) => {
      if (!latitude || !longitude) return null;
      return `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
    }
   
exports.getDirectionUrlWithNameAndAddress = (name, address) => {
  if (!name && !address) return null;

  // Prioritize address first
  const destination = encodeURIComponent(`${address}${name ? `, ${name}` : ''}`);
  return `https://www.google.com/maps/dir/?api=1&destination=${destination}`;
};
exports.getDirectionUrlWithPlaceId = (placeId, origin = 'My Location') => {
  if (!placeId) return null;

  return `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(origin)}&destination=+&destination_place_id=${encodeURIComponent(placeId)}`;
};






    exports.getStar = (type, color = "green") => {
        if(type==="full")
        return "data:image/svg+xml," + encodeURIComponent(`<svg stroke='currentColor' fill='currentColor' style='color: ${color};' stroke-width='0' viewBox='0 0 576 512' xmlns='http://www.w3.org/2000/svg'><path d='M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z'/></svg>`);
        else if(type  === "empty")
        return "data:image/svg+xml," + encodeURIComponent(`<svg stroke="currentColor" fill="currentColor"  style="color: ${color};" stroke-width="0" viewBox="0 0 576 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"></path></svg>`)
        else if ('half')
        return "data:image/svg+xml," + encodeURIComponent(`<svg stroke="currentColor" style='color: ${color};'  fill="currentColor" stroke-width="0" viewBox="0 0 536 512" xmlns="http://www.w3.org/2000/svg" ><path d="M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"></path></svg>`)
    }

    exports.directionIcon = (color = "green") => {
      
        return "data:image/svg+xml," + encodeURIComponent(`<svg aria-hidden="true" style='color: ${color};font-size:56px'  focusable="false" data-prefix="fas" data-icon="diamond-turn-right" class="svg-inline--fa fa-diamond-turn-right " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm87.6 137c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v56H224c-35.3 0-64 28.7-64 64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-8.8 7.2-16 16-16h64v56c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"></path></svg>`);
       
    }

    exports.phoneIcon = (color = "green") => {
      
        return "data:image/svg+xml," + encodeURIComponent(`<svg aria-hidden="true" style='color: ${color};'  focusable="false" data-prefix="fas" data-icon="phone" class="svg-inline--fa fa-phone " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"></path></svg>`);
       
    }

    exports.closeIcon = (color = "black") => {
      
        return "data:image/svg+xml," + encodeURIComponent(`<svg stroke="currentColor" fill="currentColor" style='color: ${color};' stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm52.7 283.3L256 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0-3.1-3.1-4.7-7.2-4.7-11.3 0-4.1 1.6-8.2 4.7-11.3l52.7-52.7-52.7-52.7c-3.1-3.1-4.7-7.2-4.7-11.3 0-4.1 1.6-8.2 4.7-11.3 6.2-6.2 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0 6.2 6.2 6.2 16.4 0 22.6L278.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6-6.2 6.3-16.4 6.3-22.6 0z"></path></svg>`);
       
    }

    exports.getStarForPopup = (rating) => {
        const numRating = parseFloat(rating);
        const fullStars = Math.floor(numRating);
        const halfStar = numRating - fullStars >= 0.5 ? 1 : 0;
        const emptyStars = 5 - fullStars - halfStar;
      
       
        let starsHtml = '';
        for (let i = 0; i < fullStars; i++) {
          starsHtml += `<img src="${this.getStar("full")}"alt="Full star" class="w-[14px]" />`;
        }
        if (halfStar === 1) {
          starsHtml += `<img src="${this.getStar("half")}"alt="Half star" class="w-[14px]" />`;
        }
        for (let i = 0; i < emptyStars; i++) {
          starsHtml += `<img src="${this.getStar("empty")}"  alt="Empty star" class="w-[14px]" />`;
        }
      
        return starsHtml;
      };



      exports.commonFetchData = async (url,parameter = {
        onErrorData: {}
      }) => {
      let {onErrorData,req,body, setLoading=null} =  parameter
      // console.log("excuting......................");
      
        try {
          const resp = await Axios[req](`${url}`,body?body:{})
          if (resp.status === 200){
            // console.log(resp);
            
            if(setLoading)
              setLoading(false)
            return resp.data
          }
        
          else{
            if(setLoading)
              setLoading(false)
            return onErrorData
          }
      
        } catch (error) {
          console.log(error)
          if(setLoading)
            setLoading(false)
          return onErrorData
        }
      }

      exports.getTodaysStartHour = (openingHours) => {
        // Ensure the input is valid
        if (!openingHours || !Array.isArray(openingHours.weekdayDescriptions)) {
          throw new Error("Invalid or missing openingHours data");
        }
      
        const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      

        const todayIndex = new Date().getDay() + 1; // No need to add +1
      

        const todayDescription = openingHours.weekdayDescriptions.find(dayDesc =>
          dayDesc.startsWith(daysOfWeek[todayIndex])
        );
      
        if (todayDescription && todayDescription.toLowerCase().includes("closed")) {
          return "Closed";
        }
      
        // Extract only the start hour (split at " - ")
        const startHour = todayDescription.split(": ")[1]?.split(" - ")[0];
      
        // Additional check to ensure startHour is valid
        return startHour || "";
      };
      

      exports.TrancateSent = (sen="",max=27)=>{
       return sen.length>max? sen.substring(0,max) + "...": sen
      }


      exports.getOpeningMessage =(openingHours)=> {
        const todayIndex = new Date().getDay(); // 0 (Sunday) - 6 (Saturday)
        const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      
        for (let i = 0; i < 7; i++) {
          const dayIndex = (todayIndex + i) % 7;
          const dayDescription = openingHours?.weekdayDescriptions[dayIndex];
          
          if (!dayDescription.includes("Closed")) {
            const [, hours] = dayDescription.split(": ");
            const openTime = hours.split(" - ")[0];
            const dayName = weekdays[dayIndex];
      
            return `Opens ${openTime} ${dayName.substring(0, 3)}`;
          }
        }
      }
      


      exports.getMon_Date = (inputDate) => {
        try {
          const date = new Date(inputDate);
      
          if (isNaN(date.getTime())) {
            throw new Error("Invalid date");
          }
      
          // Array of three-letter month names
          const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      
          // Extract month and date
          const month = months[date.getUTCMonth()];
          const day = date.getUTCDate();
      
          return { status: true, month, day };
        } catch (error) {
          return  { status:false };
        }
      };


      exports.formatFullDate = (inputDate) => {
        try {
          const date = new Date(inputDate);
      
          if (isNaN(date.getTime())) {
            throw new Error("Invalid date");
          }
      
          // Array of three-letter month names
          const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      
          // Array of day names
          const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      
          // Extract components
          const dayName = days[date.getDay()];
          const month = months[date.getMonth()];
          const day = date.getDate();
      
          // Format the time to 12-hour format with AM/PM
          let hours = date.getHours();
          const minutes = date.getMinutes().toString().padStart(2, "0");
          const amPm = hours >= 12 ? "PM" : "AM";
          hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
      
          return `${dayName} • ${month} ${day} • ${hours}:${minutes} ${amPm}`;
        } catch (error) {
          return "";
        }
      };


      exports.getLocalStorageData = (key, defaultValue = []) => {
        try {
          const storedData = localStorage.getItem(key);
          return storedData ? JSON.parse(storedData) : defaultValue;
        } catch (error) {
          console.error(`Error parsing localStorage key "${key}":`, error);
          return defaultValue;
        }
      };


exports.setLocalStorageData = (key, value, isPersist = false) => {
  try {

    const is_embedded_in_parent = localStorage.getItem("is_embedded_in_parent")
    localStorage.setItem(key, value)

    if (isPersist && is_embedded_in_parent) {
      let data = {}
      persistKeys.forEach((e) => {
        let d = localStorage.getItem(e)
        if (d)
          data[e] = JSON.parse(d)
      })
      const ev = {
        type: "INNSPIRE_SAVE_DATA",
        payload: {
          key: "trip_planner_data",
          value: JSON.stringify(data)
        }
      }
      this.dispatchEventToParent(ev)
    }
  } catch (error) {
    console.error(`Error parsing localStorage key "${key}":`, error);
  }
};


       exports.getCookie = (name) => {
        const cookieString = document.cookie.split('; ').find(row => row.startsWith(`${name}=`));
        return cookieString ? decodeURIComponent(cookieString.split('=')[1]) : null;
      };
      
      exports.setCookie = (name, value, days = 365) => {
        const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=None; Secure`;
      };

      exports.dispatchEventToParent = (eventData={}) =>{
        try {
      console.log("TP dispatching event to...........",eventData);
      window.top.postMessage(eventData, '*');
        } catch (error) {
          console.log(error);
          
        }
      }


      exports.openExtUrl = (url,mode="_blank") =>{
        const inIfr = localStorage.getItem("is_embedded_in_parent")
        try {
          if(inIfr)
          {
            const eventData = {
              type:  "INNSPIRE_OPEN_URL",
              payload: {
                url,
                target:mode
              }
            };
            
            this.dispatchEventToParent(eventData)
          }
          else
          window.open(url,mode)
        } catch (error) {
          console.log(error);
          
        }
      }


      exports.updateQueryParams = (paramsObj) => {
        let rurl = null
        try {
          if (typeof paramsObj !== 'object' || paramsObj === null) {
            throw new Error('The input must be an object');
          }
          // const params = new URLSearchParams(window.location.search);
          const params = new URLSearchParams();
      
          for (const key in paramsObj) {
            if (paramsObj.hasOwnProperty(key)) {
              const value = String(paramsObj[key]);
              params.set(key, value);
            }
          }
          // rurl = `${window.location.pathname}?${params.toString()}`
          rurl = `/?${params.toString()}`
          // console.log("redirecting Url..............",rurl);
          
          return rurl;
        } catch (error) {
          console.error('Error updating query parameters:', error.message);
          return rurl;
        }
      };


      exports.sendAnalyticsToGA = (data=null)=>{
        if (!data) {
          return 
        }
        try {
          const hotel_code = process.env.REACT_APP_HOTEL_CODE
          data.hotel_code = hotel_code
          console.log("Pushing ga for",data)
          let dataLayer = window.dataLayer || [];
          dataLayer.push(data);
          window.dataLayer = dataLayer;
        } catch (error) {
          console.log(error);

        }
      }

const getCurrency = (price, currency) => {
  if (price === null || price === undefined) return "";

  const cur = currency?.toUpperCase();

  const symbols = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    INR: "₹",
    AED: "د.إ",
    JPY: "¥",
  };

  if (!symbols[cur]) {
    return `${price} ${currency}`;
  }

  const value = Number(price);
  if (Number.isNaN(value)) {
    return `${price} ${currency}`;
  }

  const formatted =
    cur === "JPY"
      ? Math.round(value).toString()
      : Number.isInteger(value)
        ? value.toString()
        : value.toFixed(2).replace(/\.00$/, "");

  return `${symbols[cur]}${formatted}`;
};

const getPriceMetaParts = (cost, configs) => {
  if (!cost || !configs) return null;

  return {
    prefix: "From",
    price: getCurrency(cost, configs.currency),
    meta: [
      configs.ticket_info?.quantity || null,
      configs.booking_requirements?.max_travelers
        ? `Up to ${configs.booking_requirements.max_travelers} people`
        : null,
    ].filter(Boolean),
  };
};

exports.getCurrency = getCurrency;
exports.getPriceMetaParts = getPriceMetaParts;

